import { IBannerStretchSchema } from '../../../repositories/developer-card/entities/developer_special_promo/BannerStretchSchema';
import { IApplicationState } from '../../../types/redux';
import { getTemplateSpecialPromo } from './getTemplateSpecialPromo';

export function getTemplateSpecialPromoBannerStretch(state: IApplicationState): IBannerStretchSchema | undefined {
  return getTemplateSpecialPromo(state)?.bannerStretch;
}
